/*
  Preview thumbnails on product cards (snippets/isaboko-card-thumbs.liquid).

  With a mouse: hovering a thumbnail swaps the card's main image, leaving the
  card puts the card's own image back. Without that reset, dragging the pointer
  across a grid leaves a trail of cards showing their third photo.

  With touch: there is no hover, so a tap does the swap instead of following the
  thumbnail's link to the product page, and the swapped image stays put — the
  tap is a choice, not a pass-over. The card's main image still links through.

  One delegated set of listeners rather than per-card ones: facet filtering
  replaces the entire product grid, and delegation survives that with nothing
  to re-bind.
*/
(function () {
  if (window.isabokoCardThumbs) return;
  window.isabokoCardThumbs = true;

  var THUMB = 'isaboko-card-thumbs__thumb';
  var ACTIVE = 'isaboko-card-thumbs__thumb--active';

  // Touch taps also emit emulated mouseover/mouseout, which would fight the tap
  // behaviour below — a tap would swap and then immediately restore. pointerover
  // fires before those emulated events for both input types, so the flag is
  // always current by the time a mouse handler runs. matchMedia is the fallback
  // for browsers without pointer events.
  var hoverQuery = window.matchMedia('(hover: hover)');
  var pointerIsTouch = false;

  document.addEventListener('pointerover', function (event) {
    pointerIsTouch = event.pointerType === 'touch';
  });

  function closestFrom(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function mainImage(wrapper) {
    return wrapper.querySelector('.card__media img');
  }

  function setActive(thumbs, thumb) {
    thumbs.querySelectorAll('.' + ACTIVE).forEach(function (el) {
      el.classList.remove(ACTIVE);
    });
    if (thumb) thumb.classList.add(ACTIVE);
  }

  function showThumb(thumb) {
    var wrapper = thumb.closest('.card-wrapper');
    var img = wrapper && mainImage(wrapper);
    if (!img) return;

    // Stash the card's own image on the first swap so mouseout can restore it.
    if (img.dataset.thumbsOriginalSrc === undefined) {
      img.dataset.thumbsOriginalSrc = img.getAttribute('src') || '';
      img.dataset.thumbsOriginalSrcset = img.getAttribute('srcset') || '';
    }

    img.setAttribute('src', thumb.dataset.mainSrc);
    img.setAttribute('srcset', thumb.dataset.mainSrcset);
    setActive(thumb.parentElement, thumb);
  }

  document.addEventListener('mouseover', function (event) {
    if (pointerIsTouch) return;

    var thumb = closestFrom(event.target, '.' + THUMB);
    if (!thumb) return;

    showThumb(thumb);
  });

  document.addEventListener('mouseout', function (event) {
    if (pointerIsTouch) return;

    var wrapper = closestFrom(event.target, '.card-wrapper');
    if (!wrapper) return;
    // mouseout also fires on moves between elements inside the card; only a
    // move to something outside the card counts as leaving it.
    if (wrapper.contains(event.relatedTarget)) return;

    var thumbs = wrapper.querySelector('.isaboko-card-thumbs');
    var img = mainImage(wrapper);
    if (!thumbs || !img || img.dataset.thumbsOriginalSrc === undefined) return;

    img.setAttribute('src', img.dataset.thumbsOriginalSrc);
    img.setAttribute('srcset', img.dataset.thumbsOriginalSrcset);
    setActive(thumbs, thumbs.querySelector('.' + THUMB));
  });

  document.addEventListener('click', function (event) {
    // A mouse click on a thumbnail keeps its link behaviour: the image is
    // already previewed by hover, so the click can only mean "take me there".
    if (!pointerIsTouch && hoverQuery.matches) return;

    var thumb = closestFrom(event.target, '.' + THUMB);
    if (!thumb) return;

    event.preventDefault();
    showThumb(thumb);
  });
})();
